import React from 'react';
function Label({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M3.65 6.375C3.65 4.79594 4.77199 3.65 6 3.65H18C19.228 3.65 20.35 4.79594 20.35 6.375V17.625C20.35 19.2041 19.228 20.35 18 20.35H6C4.77199 20.35 3.65 19.2041 3.65 17.625V6.375Z" />
      <path
        d="M10 7V15.5C10 15.5 10 16.5 11 16.5C12 16.5 15.5 16.5 15.5 16.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Label;
